import { useMemo } from 'react'

export function useMonoNumbers(text: string) {
  return useMemo(() => {
    // if (!text) {
    //   console.error('Invalid input: text must be a string', text)
    //   return []
    // }

    // console.log('useMonoNumbers', text)
    const parts = text.split(/(\d+(?:\.\d+)?)/g)

    return parts.map(part => ({
      isNumber: /^\d/.test(part),
      text: part
    }))
  }, [text])
}
